import { useEffect, useState } from "react";
import { Select, Input, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { startGetEstadosProveedores, startSetMunicipio } from "../../../../context/actions/proveedoresActions";

const AgregarMunicipios = () => {
  const dispatch = useDispatch();
  const { estadosProveedores } = useSelector((state) => state.proveedoresReducer);
  const [estadoId, setEstadoId] = useState(undefined);
  const [nombre, setNombre] = useState("");

  useEffect(() => {
    dispatch(startGetEstadosProveedores());
  }, [dispatch]);

  const handleSubmit = async () => {
    if (!estadoId || !nombre) return;
    const result = await dispatch(startSetMunicipio({ estadoId, nombre }));
    if (result && result.code === 0) setNombre("");
  };

  return (
    <>
      <div style={{ marginBottom: 16 }}>
        <label>Estado ID</label>
        <Select
          style={{ width: "100%" }}
          placeholder="Seleccionar estado"
          allowClear
          value={estadoId}
          onChange={setEstadoId}
          options={estadosProveedores.map((e) => ({
            label: `${e.estadoId}${e.nombre ? ` - ${e.nombre}` : ""}`,
            value: e.estadoId,
          }))}
        />
      </div>
      <div style={{ marginBottom: 16 }}>
        <label>Nombre</label>
        <Input
          placeholder="Nombre"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
        />
      </div>
      <Button type="primary" onClick={handleSubmit}>
        Guardar
      </Button>
    </>
  );
};

export default AgregarMunicipios;
